'use client';
import Image from 'next/image';

import { onest } from '@/styles/fonts';
import useGetWhyChooseUs from '@/features/api/use-get-why-choose-use';
import WhyChooseUsSkeleton from './why-choose-us-skeleton';
import CustomLink from '@/components/custom-link';
import { cn } from '@/lib/utils';

const WhyChooseUs = () => {
  const cdnUrl = process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_DOMAIN;
  const { data, isLoading } = useGetWhyChooseUs();

  return (
    <section className="mx-auto max-w-[800px] px-4 py-10 xm:px-5 md:pt-[45px] lg:px-0 lg:py-[50px]">
      <div>
        <h2 className="text-center text-[2.125rem] font-semibold leading-9 xl:font-[2.375rem]">
          Why Choose Us
        </h2>
        <p
          className={`${onest.className} px-4 pt-6 text-center text-[1rem] text-rm-neutral-600 md:px-0 md:pt-5 xl:text-lg`}
        >
          Discover why R&M Bindery is the trusted partner for print houses. With
          expert craftsmanship and fast, reliable service, we&apos;re dedicated
          to enhancing your projects with top-tier bindery and finishing
          solutions.
        </p>
        <div className="relative mt-[30px] min-h-[320px] w-full xm:min-h-[460px] lg:mt-[34px] lg:min-h-[500px] xl:mt-8">
          <Image
            src={`${cdnUrl}/home/why-choose-us/warehouse.webp`}
            alt="warehouse with machines"
            fill
            sizes="(max-width: 768px) 100vw, (min-width: 768px) 460px, 800px"
            priority
            className="rounded-[16px] object-cover"
          />
        </div>
      </div>
      <div
        className={cn(
          'shadow-xm mt-5 flex flex-col items-center gap-y-[90px] rounded-[16px] border border-rm-neutral-200 px-6 py-9 xm:px-7 md:gap-[35px] md:px-[25px] md:py-[30px] lg:mt-6 lg:px-[40px] lg:py-[45px] xl:mt-8',
          isLoading && 'gap-y-[8px]'
        )}
      >
        {isLoading ? (
          <WhyChooseUsSkeleton />
        ) : (
          data?.map((item) => (
            <article
              key={item._id}
              className="flex flex-col items-center gap-y-[10px] xm:flex-row xm:gap-x-10"
            >
              <div className="flex h-10 min-h-[40px] w-10 min-w-[40px] items-center justify-center rounded-full bg-rm-neutral-200 text-[1rem] font-semibold text-rm-neutral-700 xl:text-lg">
                {item.order}
              </div>
              <div className="flex flex-col gap-y-[10px]">
                <h3 className="text-center text-2xl font-semibold text-rm-neutral-700 xm:text-left xl:text-[1.625rem]">
                  {item.title}
                </h3>
                <p
                  className={`${onest.className} text-center text-[1rem] text-rm-neutral-600 xm:text-left xl:text-lg`}
                >
                  {item.description}
                </p>
              </div>
            </article>
          ))
        )}
      </div>
      <div className="mt-[30px] flex flex-col items-center justify-center gap-5 xm:flex-row xm:gap-4 lg:mt-[34px]">
        <CustomLink
          href="/contact-us"
          variant={'primary'}
          className="xm:max-w-[305px]"
        >
          Request a Quote
        </CustomLink>
        <CustomLink
          href="/services"
          variant={'secondary'}
          className="xm:max-w-[305px]"
        >
          Browse All Services
        </CustomLink>
      </div>
    </section>
  );
};

export default WhyChooseUs;
